import fetch from "cross-fetch";
import { v4 as uuidv4 } from "uuid";
import { setChatHistory, getChatHistory, clearChatHistory, setCurrentSurvey} from "../Helpers/Storage";

class Ajax {
  constructor(config) {
    this.config =                               config;
    this.ongoingChat =                          getChatHistory(config.tag.survey_id);
    this.them =                                 this.ongoingChat.them || `Web ${Date.now()} ${uuidv4()}`;
    this.at =                                   config.tag.at;
    this.survey_id =                            config.tag.manually_triggered_survey_id || config.tag.survey_id;
    this.configuration_id =                     config.tag.configuration_id;
    this.trigger_override =                     config.tag.trigger_override;
    this.endpoint =                             config.tag.endpoint || "https://app.chatterresearch.com";

    this.initiate_endpoint =                    this.endpoint + "/api/v2/web_chat/initiate";
    this.send_response_endpoint =               this.endpoint + "/api/v2/web_chat/send_response";
    this.fetch_configuration_endpoint =         this.endpoint + "/api/v2/web_chat/website_configuration";
    this.initiate_live_conversation_endpoint =  this.endpoint + "/api/v2/web_chat/initiate_live_conversation";
    this.get_survey_configuration_endpoint =    this.endpoint + "/api/v2/web_chat/get_survey_configuration";
    this.keep_history_after_completion =        !!config.tag.keep_history_after_completion || false;
    this.locale =                               config.tag.locale || navigator.language;
  }


  preparePayload = (params = null) => {
    let payload = {};

    // add params if provided
    if (params && Object.entries(params).length) { payload = { ...params }; };

    if (this.trigger_override)  payload.trigger_override = this.trigger_override;
    if (this.at)                payload.api_token = this.at;
    if (this.survey_id)         payload.survey_id = this.survey_id;
    if (this.them)              payload.them = this.them;
    if (this.locale)            payload.locale = this.locale;
    if (this.configuration_id)  payload.website_configuration_id = this.configuration_id;

    // process conversation metadata
    this.metadata = this.config.metadata || {};
    if (this.metadata) payload.metadata = this.metadata;
    return { _chatter_data: btoa(JSON.stringify(payload)) };;
  };

  initiate = async config => {
    if (!!config.tag.manually_triggered_survey_id && config.tag.manually_triggered_survey_id !== this.survey_id) {
      this.survey_id = config.tag.manually_triggered_survey_id;
    }
    setCurrentSurvey(this.survey_id);
    if (this.ongoingChat.messages && this.ongoingChat.messages.filter(m  => m.type == "answer").length) {
      return this.ongoingChat;
    }
    let encoded_payload = this.preparePayload();

    const res = await fetch(
      this.initiate_endpoint, 
      {
        method: "post",
        body:   JSON.stringify(encoded_payload),
        headers: {
          "Content-Type":     "application/json",
          "X-Chatter-Source": "live_insights_tag"
        }
      }
    );
    
    const response_data = await res.json();
    const {responses, ...metadata} = response_data;

    // this.responses = responses;
    this.metadata = metadata;
    this.ongoingChat = {
      them:             this.them, 
      acceptedAnswers:  metadata.accepted_answers, 
      messages:         responses.map(r => ({content: r, type: "question"}))
    };

    // create conversation entry in local storage
    setChatHistory(this.survey_id, this.ongoingChat);

    return response_data;
  };

  sendAnswer = async answer => {
    let encoded_payload = this.preparePayload({resp: answer});

    const res = await fetch(
      this.send_response_endpoint,
      {
        method:   "post",
        body:     JSON.stringify(encoded_payload),
        headers:  {
          "Content-Type":     "application/json",
          "X-Chatter-Source": "live_insights_tag"
        }
      }
    );

    const response_data = await res.json();

    // add answer and new questions to the storage
    if (response_data.complete && !this.keep_history_after_completion) {
      clearChatHistory(this.survey_id);
    } else {
      this.ongoingChat = getChatHistory(this.survey_id);
      this.ongoingChat.acceptedAnswers = response_data.accepted_answers;
      this.ongoingChat.messages = [
        ...this.ongoingChat.messages, 
        {content: answer, type: "answer"}, 
        ...response_data.responses.map(r => ({content: r, type: "question"}) )
      ];
      setChatHistory(this.survey_id, this.ongoingChat);
    }
    
    return response_data;
  };

  getSurveyConfiguration = async() => {
    const res = await fetch(
      this.get_survey_configuration_endpoint + "?" + new URLSearchParams({
        api_token: this.at,
        website_configuration_id: this.configuration_id,
        survey_id: this.survey_id,
        locale: this.locale
      })
    );

    let result = await res.json();

    return result;
  };

  initiateLiveConversation = async(locationValue, name, phoneNumber, messageFromCustomer, messageToCustomer) => {
    let encoded_payload = this.preparePayload({
      location_trigger: locationValue,
      conversation_name: name,
      customer_phone_number: phoneNumber,
      message_from_customer: messageFromCustomer,
      message_to_customer: messageToCustomer
    });

    const res = await fetch(
      this.initiate_live_conversation_endpoint,
      {
        method:   "post",
        body:     JSON.stringify(encoded_payload),
        headers:  {
          "Content-Type":     "application/json",
          "X-Chatter-Source": "live_insights_tag"
        }
      }
    );

    return await res.json();
  };


  fetchConfiguration = async() => {
    const res = await fetch(
      this.fetch_configuration_endpoint + "?" + new URLSearchParams({
        api_token: this.at,
        website_configuration_id: this.configuration_id
      })
    );
    const response_data = await res.json();
    return response_data;
  };
};

export default Ajax;
